import type { FormikErrors } from 'formik';

export const TE_CONSTANTS = {
  ADD_ITEM: 'Add Item',
  ADD_CONTENT_BLOCK: 'Add Content Block',
  UNORDERED: 'unordered',
  ORDERED: 'ordered',
};

export interface SetFieldValue {
  (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ): Promise<void | FormikErrors<any>>;
  (arg0: string, arg1: string): void;
}
